export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}form/form-category/:id`;

    return $resource(url, null, {
        tree: {
            method: 'GET',
            url: `${url}/index-tree`,
            isArray: true
        },
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/FormCategory/index.js